import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { ROUTE_PATHS, PRICE_SCHEDULE_MODES } from "../../../common_nextgen/utils/Constants";
import getBackendUrl from "../../../environment/BackendService";
import { downloadCSV } from "../../../common_nextgen/utils/UtilFunctions";
import {
  useLocationState,
  useReceiveExternalMessages,
} from "../../../common_nextgen/common_components/common-hooks/useLocationState";
import { useRBAC } from "../../../common_nextgen/hooks/RBACContext";

const useDeductibleScheduleSteps = () => {
  const {writeAccess} = useRBAC();
  const [data, setData] = useState([]); /* Deductible Schedule Steps Data */
  const location = useLocation();
  const {
    ADD_DEDUCTIBLE_SCHEDULE_STEP,
    EDIT_DEDUCTIBLE_SCHEDULE_STEP,
    DISPLAY_DEDUCTIBLE_SCHEDULE_STEP,
    DEDUCTIBLE_SCHEDULE_STEP_DETAIL_EXTENSION,
    PATIENT_PAY_SCHEDULES,
    DEDUCTIBLE_SCHEDULE,
  } = ROUTE_PATHS;
  /* const { state: stateVal } = location;
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  console.log("current state in form", currentState, previousState);*/
  const { currentState, previousState, setStateVal } = useLocationState({
    initialState: location.state || [],
  });
  const {
    selectedSchedules = [],
    previousScreen = DEDUCTIBLE_SCHEDULE,
    currentIndex: initialIndex = 0,
    externalMode: initialExternalMode = false,
    initialParamsData = {
      dscScheduleName: selectedSchedules[initialIndex]?.dscScheduleName,
      dscBasis: selectedSchedules[initialIndex]?.dscBasis,
      basisDescription: "",
      dscStepCount: selectedSchedules[initialIndex]?.dscStepCount,
      dscDescription: selectedSchedules[initialIndex]?.dscDescription,
    },
  } = currentState;
  console.log("InitialparamsData", initialParamsData, previousState);
  const [paramsData, setParamsData] = useState(initialParamsData);

  const [first, setFirst] = useState(0);
  const [screenInfo, setScreenInfo] = useState({});
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const [externalMode, setExternalMode] = useState(initialExternalMode);
  const toast = useToast();
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const screen_title = "Deductible Schedule Steps";
  const screenNumber = "RCDSD001";
  const { axios_helper_no_header } = useAxios();
  useReceiveExternalMessages(setStateVal, setExternalMode);
  const [fetchDataParam, setFetchDataParam] = useState({
    dscScheduleName: selectedSchedules[currentIndex]?.dscScheduleName,
  });

  useEffect(() => {
    if (selectedSchedules.length > 0) {
      const dscScheduleName = selectedSchedules[currentIndex]?.dscScheduleName;
      setFetchDataParam({ dscScheduleName });
    }
  }, [currentIndex, selectedSchedules]);

  /* Search form fields that needs to be shown for filtering */
  const [formFields, setFormFields] = useState([
    {
      fieldLabel: "Schedule",
      name: "dscScheduleName",
      label: "Schedule",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 10,
    },
    {
      fieldLabel: "Description",
      name: "dscDescription",
      label: "Description",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 40,
    },
    {
      fieldLabel: "DSC Basis*Valid values",
      name: "dscBasis",
      label: "Basis",
      type: "dropdown",
      fieldNature: "readOnly",
      value: "",
      maxLength: 20,
    },
    {
      fieldLabel: "Steps",
      name: "dscStepCount",
      label: "Steps",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 2,
    },
  ]);

  const updateFormFields = (response) => {
    setFormFields((prevFields) =>
      prevFields.map((field) => {
        switch (field.name) {
          case "schedule":
            return { ...field, value: response.dscScheduleName };
          case "description":
            return { ...field, value: response.dscDescription };
          case "basis":
            return { ...field, value: response.dscBasis };
          case "steps":
            return { ...field, value: response.dscStepCount };
          default:
            return field;
        }
      })
    );
  };

  /* const scheduleName = formFields.find(
    (field) => field.name === "dscScheduleName"
  ).value;*/

  /* Dropdown options fields that needs to be fetched with API */
  const dropdownOptions = [
    { field_label: "DSC Basis", condition: "*Valid values" },
  ];

  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
  };

  /* ACTION BUTTONS info that needs to be displayed on the page */
  const ctaButtons = [
    {
      button_label: "Add Deductible Schedule Steps",
      button_handeler: () => {
        const { dsdStepNumber, dsdCrossOverFlag } = rowData;
        navigateToPage(ADD_DEDUCTIBLE_SCHEDULE_STEP, [
          ...previousState,
          { ...currentState, currentIndex, externalMode },
          {
            previousScreen: location.pathname,
            scheduleName: paramsData.dscScheduleName,
            currentIndex: 0,
          },
        ]);
      },
      button_key: "F6",
    },
    {
      button_label: "Export as CSV",
      button_handeler: () => {
        exportAsCSV();
      },
      button_key: "",
    },
  ];

  /* Gear Icon Menu option CTAs */

  const menuOptions = [
    {
      label: "Edit",
      icon: <span className="material-icons">edit</span>,
      command: () => {
        const { dsdStepNumber, dsdCrossOverFlag } = rowData;
        navigateToPage(EDIT_DEDUCTIBLE_SCHEDULE_STEP, [
          ...previousState,
          { ...currentState, currentIndex, externalMode },
          {
            selectedSteps: selectedRows.length
              ? selectedRows
              : [{ dsdStepNumber, dsdCrossOverFlag }],
            scheduleName: selectedSchedules[currentIndex].dscScheduleName,
            previousScreen: location.pathname,
            currentIndex: 0,
            paramsData,
          },
        ]);
      },
    },
    {
      label: "Delete",
      icon: <span className="material-icons">delete</span>,
      command: () => {
        openConfirmationModal();
      },
    },
    {
      label: "Display",
      icon: <span className="material-icons">visibility</span>,
      command: () => {
        const { dsdStepNumber, dsdCrossOverFlag } = rowData;
        navigateToPage(DISPLAY_DEDUCTIBLE_SCHEDULE_STEP, [
          ...previousState,
          { ...currentState, currentIndex, externalMode },
          {
            selectedSteps: selectedRows.length ? selectedRows : [rowData],
            scheduleName: paramsData.dscScheduleName,
            previousScreen: location.pathname,
            currentIndex: 0,
            paramsData,
          },
        ]);
      },
    },
    {
      label: "Detail Extension",
      icon: <span className="material-icons">extension</span>,
       command: async () => {
        if (!writeAccess) {
          const {
            dscScheduleName,
            dsdStepNumber,
            dscDescription,
            dsdCrossOverFlag,
          } = rowData;
          const { responseData } = await axios_helper_no_header(
            "GET",
            "api/ddeDedSchDtlExt/initialFormData/RCDDE001",
            null,
            { dscScheduleName, dsdStepNumber, dscDescription, dsdCrossOverFlag }
          );
          const { addDate } = responseData;
          if (addDate) {
            navigateToPage(DEDUCTIBLE_SCHEDULE_STEP_DETAIL_EXTENSION, [
              ...previousState,
              { ...currentState, currentIndex, externalMode },
              {
                selectedSteps: selectedRows.length ? selectedRows : [rowData],
                currentIndex: 0,
                previousScreen: location.pathname,
                currentMode: PRICE_SCHEDULE_MODES.READ_ONLY,
              },
            ]);
          } else {
            toast.current.show({
              severity: "info",
              summary: "",
              detail: "Detail Extension not present",
              life: 3000,
            });
          }
        } else {
          navigateToPage(DEDUCTIBLE_SCHEDULE_STEP_DETAIL_EXTENSION, [
            ...previousState,
            { ...currentState, currentIndex, externalMode },
            {
              selectedSteps: selectedRows.length ? selectedRows : [rowData],
              currentIndex: 0,
              previousScreen: location.pathname,
            },
          ]);
        }
      },
    },
    {
      label: "Patient Pay Schedules",
      icon: <span className="material-icons">schedule</span>,
      command: () => {
        console.log("parent", selectedRows);
        patientsPayValidation();
      },
    },
  ];

  /* Data table column info. */
  const columnDef = [
    { header: "Step", field: "dsdStepNumber" },
    { header: "Accum Component Code", field: "dsdAccumComponentCode" },
    { header: "Deductible Individual Amount", field: "dsdMbrDeductibleAmount" },
    { header: "Deductible Family Amount", field: "dsdFamDeductibleAmount" },
    { header: "Copay Patient Pay Table", field: "dsdPricingTableFlag" },
    { header: "Brand Copay Amount", field: "dsdBrandCopayAmount" },
    { header: "Generic Copay Amount", field: "dsdGenericCopayAmount" },
    { header: "Brand Percent Amount", field: "dsdBrandPercentAmt" },
    { header: "Generic Percent Amount", field: "dsdGenericPercentAmt" },
    { header: "Percent Basis", field: "dsdPercentBasis" },
    { header: "Update Copay", field: "dsdCopayDeductibleFlag" },
  ];

  /* Param Key which used as bridge between various operations on tabluar data */
  const parmKey1 = "dscScheduleName";
  const parmKey2 = "dsdStepNumber";

  const fetchDisplayParamsData = (response) => {
    setParamsData({
      ...paramsData,
      dscScheduleName: response.dscScheduleName,
      dscDescription: response.dscDescription,
      dscStepCount: response.dscStepCount,
      dscBasis: response.dscBasis,
    });
  };

  useEffect(() => {
    if (!paramsData.dscScheduleName) {
      setParamsData(initialParamsData);
      fetchSubScreenInfo(initialParamsData);
    }
  }, [initialParamsData]);

  const fetchData = async () => {
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/dsdDeductibleSchDtl/fetchStepsData`,
        null,
        { page: page, size: rows, ...fetchDataParam }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        updateFormFields(response[0]);
        setTotalRecords(pageResponse.totalRecords);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  const handleBack = () => {
    if (externalMode) {
      const message = {
        message: "navigate-to-external-program",
        url: previousScreen,
        parameters: {
          state: [...previousState],
        },
      };
      console.log("back messages", message);
      window.parent.postMessage(message, "*");
    } else if (currentIndex < selectedSchedules.length - 1) {
      setCurrentIndex((prevIndex) => prevIndex + 1);
      setExternalMode(false);
    } else {
      navigateToPage(previousScreen, previousState);
    }
  };

  /* Top Left Back button info that needs to be displayed on the page*/
  const leftButtons = [
    { button_label: "Back", button_handeler: handleBack, button_key: "F12" },
  ];

  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, []);

  useEffect(() => {
    const hasParams =
      paramsData &&
      Object.keys(paramsData).length &&
      paramsData.dscScheduleName;
    if (hasParams) fetchData(); // Initial fetch with page 0 and page size 10
  }, [paramsData.dscScheduleName, rows, currentPage, currentIndex]);

  useEffect(() => {
    fetchSubScreenInfo(initialParamsData);
  }, [currentIndex]);

  const onPageChange = (event) => {
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const deleteDeductibleSchedule = () => {
    if (selectedOption === "yes") {
      const params = {
        dscScheduleName: rowData[parmKey1],
        dsdStepNumber: rowData[parmKey2],
      };
      axios_helper_no_header("DELETE", "api/dsdDeductibleSchDtl", null, params)
        .then((response) => {
          const updatedItems = data.filter(
            (item) => item[parmKey1] !== rowData
          );
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeConfirmationModal();
          if (currentPage > 0) {
            setFirst(0);
            setCurrentPage(0);
          } else {
            fetchData();
          }
        })
        .catch((error) => {
          console.error("There was an error deleting the data!", error);
          const {
            responseStatus: { displayErrorFields = null, message } = {},
          } = error.data;
          toast.current.show({
            severity: "error",
            summary: "",
            detail: message,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = { ...paramsData };
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/dsdDeductibleSchDtl/exportCsvForStepsData",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const fetchSubScreenInfo = (paramsData) => {
    const params = { notesRequiredFlag: false };
    const hasValidParams =
      paramsData &&
      Object.keys(paramsData).length &&
      paramsData.dscScheduleName;
    if (hasValidParams) {
      axios_helper_no_header(
        "GET",
        "api/dscDeductibleSchCtrl/" +
          encodeURIComponent(selectedSchedules[currentIndex].dscScheduleName),
        null,
        params
      )
        .then((response) => {
          fetchDisplayParamsData(response.responseData, dropdownValues);
          setScreenInfo({ ...screenInfo, ...response.responseData });
        })
        .catch((error) => {
          const errorMessage =
            error.data?.responseStatus?.message || error.message;
          console.error("There was an error deleting the data!", error);
          toast.current.show({
            severity: "error",
            summary: "",
            detail: errorMessage,
            life: 3000,
          });
          closeConfirmationModal();
        });
    }
  };

  const patientsPayValidation = () => {
    const params = {
      dscScheduleName: rowData[parmKey1],
      dsdStepNumber: rowData[parmKey2],
    };
    axios_helper_no_header(
      "GET",
      "api/dsdDeductibleSchDtl/validateBeforePatientsPay",
      null,
      params
    )
      .then((response) => {
        navigateToPage(PATIENT_PAY_SCHEDULES, [
          ...previousState,
          { ...currentState, currentIndex, externalMode },
          {
            selectedSteps: selectedRows.length ? selectedRows : [rowData],
            description: paramsData.dscDescription,
            stepNumber: rowData.dsdStepNumber,
            scheduleName: paramsData.dscScheduleName,
            previousScreen: location.pathname,
          },
        ]);
      })
      .catch((error) => {
        console.error("There was an error editing the data!", error);
        const { responseStatus: { displayErrorFields = null, message } = {} } =
          error.data;
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      });
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    leftButtons,
    data,
    parmKey1,
    parmKey2,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deleteDeductibleSchedule,
    setSelectedOption,
  };
};

export default useDeductibleScheduleSteps;
